import { useLearningCourses } from "@/hooks/use-learning-courses";
import type { NavGroup } from "@/navigation/sidebar-items";
import { CourseSeatNavigation } from "./CourseSeatNavigation";

export function LearningNavigation({ group }: { group: NavGroup }) {
  const query = useLearningCourses();
  return <CourseSeatNavigation group={group} query={query} capacityLabel="Learning" hideNoSeat />;
}
